import { render } from "./formJuchuumaeKaitou.vue?vue&type=template&id=1bdae798"
import script from "./formJuchuumaeKaitou.vue?vue&type=script&lang=js"
export * from "./formJuchuumaeKaitou.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__